import api from '../token';

export const GetExtenso = async (produto) => {
  try {
    const response = await api.post('/converter', produto);
    return response.data;
  } catch (error) {
    console.error('Erro ao adicionar produto:', error);
    return { success: false, message: error.message };
  }
};



